import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ForecastsByCompany from './ForecastsByCompany';
import CompanyMediaObject from './CompanyMediaObject';
import { fetchCurrentForecasts } from '../../actions';
import QuickViewContext from '../../../../components/QuickView/QuickViewContext';

import {
  currentForecastSettingsSelector,
  currentForecastFiltersSelector,
  currentForecastSelector,
  activeForecastSelector,
} from '../../selectors';

const ForecastsContent = () => {
  const dispatch = useDispatch();

  const settings = useSelector(currentForecastSettingsSelector);
  const filters = useSelector(currentForecastFiltersSelector);
  const data = useSelector(currentForecastSelector);
  const activeForecast = useSelector(activeForecastSelector);

  const { onCompanyQuickViewOpen } = useContext(QuickViewContext);

  const handleFiltersChange = (nextFilters) => {
    dispatch(fetchCurrentForecasts(nextFilters));
  };

  const handleTickerClick = () => {
    onCompanyQuickViewOpen({ ref_no: data.forecast?.[0]?.forecasts?.company_id });
  };

  const preHeader = (
    <div className="kpi-forecasts-block__main-content-prehead">
      <CompanyMediaObject
        name={activeForecast?.name}
        ticker={activeForecast?.ticker}
        icon={activeForecast?.icon_url}
        onClick={handleTickerClick}
      />
    </div>
  );

  return (
    <ForecastsByCompany
      settings={settings}
      filters={filters}
      data={data}
      activeForecast={activeForecast}
      preHeader={preHeader}
      onFiltersChange={handleFiltersChange}
    />
  );
};

export default ForecastsContent;
